import React from "react";
import { Stack, Title } from "@mantine/core";
import { SortParams } from "../../../components/AdminDataTable";
import { router } from "@inertiajs/react";
import VehicleList from "../shared/components/VehicleList";
import { AdminVehiclesIndexProps } from "./types";

const AdminVehiclesIndex: React.FC<AdminVehiclesIndexProps> = (props) => {
  const { title, vehicles, pagination, sort } = props;

  const onSortChange = (s: SortParams) => {
    if (!s.order) {
      router.get("/admin/vehicle_versions", {
        page: 1,
        per_page: pagination.per_page,
      });
    } else {
      router.get("/admin/vehicle_versions", {
        page: 1,
        per_page: pagination.per_page,
        sort: s.key,
        order: s.order,
      });
    }
  };

  const onPaginationChange = (page: number, perPage: number) => {
    router.get("/admin/vehicle_versions", {
      page,
      per_page: perPage,
      sort: sort.key,
      order: sort.order,
    });
  };

  return (
    <Stack gap="md">
      <Title order={2}>{title}</Title>
      <VehicleList
        vehicles={vehicles}
        pagination={pagination}
        sort={sort}
        onPaginationChange={onPaginationChange}
        onSortChange={onSortChange}
        onRowClick={(record) =>
          router.visit(`/admin/vehicle_versions/${record.id}`)
        }
      />
    </Stack>
  );
};

export default AdminVehiclesIndex;
